import informationUpdatesApi from "../../api/informationUpdates";

const state = {
  completedUpdates: [],
  incompleteUpdates: []
};

const getters = {};

const actions = {
  getUpdates(context) {
    informationUpdatesApi
      .getIncompleteUpdates()
      .then(function(response) {
        context.commit("updateIncompleteUpdates", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });

    informationUpdatesApi
      .getCompletedUpdates()
      .then(function(response) {
        context.commit("updateCompletedUpdates", response.data);
      })
      .catch(function(error) {
        console.log(error);
      });
  },

  completeUpdate({ dispatch }, informationUpdate) {
    console.log(informationUpdate);
    return new Promise((resolve, reject) => {
      informationUpdatesApi
        .postComplete(informationUpdate)
        .then(function(response) {
          dispatch("getUpdates");
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
};

const mutations = {
  updateCompletedUpdates(state, value) {
    state.completedUpdates = value;
  },

  updateIncompleteUpdates(state, value) {
    state.incompleteUpdates = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
